import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../../../utils/events'
import { EntityTag } from '../../../../../Entity'
import { FloatingTooltipContentText } from '../../../../../Floating'
import { TAG_HEIGHT } from '../../../../../Tag'
import { QA_NAME_TAG_ITEM } from '../NewsboardPostBodyMessage.constants'

import * as styles from './ListItem.module.css'

function ListItem({
  Icon,
  avatar,
  hoverable,
  id,
  title,
  to,
  onClick,
  onMouseDown,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    stopPropagation(event)

    onClick?.({ event, id, to })
  }

  function handleMouseDown(event) {
    stopPropagation(event)

    onMouseDown?.({ event, id, to })
  }

  return (
    <div className={styles.listItem}>
      <EntityTag
        avatarProps={{
          Icon,
          className: styles.avatar,
          src: avatar,
        }}
        height={TAG_HEIGHT.height40}
        name={title}
        qaName={QA_NAME_TAG_ITEM}
        tooltip={
          <FloatingTooltipContentText
            additionalText={
              hoverable ? t('Newsboard.ClickToOpenTagLinkKey') : null
            }
            text={title}
          />
        }
        onClick={hoverable ? handleClick : undefined}
        onMouseDown={hoverable ? handleMouseDown : undefined}
      />
    </div>
  )
}

export default ListItem
